import { useState } from 'react';
import { Header } from './components/Header';
import { TabBar, Tab } from './components/TabBar';
import { Results } from './pages/Results';
import { Today } from './pages/Today';
import { Workouts } from './pages/Workouts';
import { PasskeyGate } from './components/PasskeyGate';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState<Tab>('today');

  return (
    <PasskeyGate>
      <div className="app">
        <Header />
        <div className="content">
          {activeTab === 'results' && <Results />}
          {activeTab === 'today' && <Today />}
          {activeTab === 'workouts' && <Workouts />}
        </div>
        <TabBar activeTab={activeTab} onTabChange={setActiveTab} />
      </div>
    </PasskeyGate>
  );
}

export default App;
